const TOGGLE_MONTHLY_EVENT_ITEM_TO_DELETE = "TOGGLE_MONTHLY_EVENT_ITEM_TO_DELETE"
const RESET_MONTHLY_EVENT_ITEM_TO_DELETE_ARRAY = "RESET_MONTHLY_EVENT_ITEM_TO_DELETE_ARRAY"

export {
  TOGGLE_MONTHLY_EVENT_ITEM_TO_DELETE,
  RESET_MONTHLY_EVENT_ITEM_TO_DELETE_ARRAY
}